import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LeaveAlert from "../components/Popups/LeaveAlert";
import { useAuthContext } from "../context/AuthContext";
import { useCallbackPrompt } from "../hooks/useCallbackPrompt";
import {
  setIsCompleteRegister,
  setIsUserForgettingPassword,
  setIsUserRegistering,
  updateOTPDuration,
} from "../redux/slices/authSlice";
import { RootState } from "../redux/store";

const AuthGuard: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showLeaveAuthRoutePopup, changeShowLeaveAuthRoutePopupAuthState } =
    useAuthContext();

  const { isUserRegistering, isUserForgettingPassword, isCompleteRegister } =
    useSelector((state: RootState) => state.auth);

  const { user, isAuthenticated } = useSelector(
    (state: RootState) => state.auth,
  );
  //?===================Prevent Navigation Hook========================
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
    showLeaveAuthRoutePopup,
  );
  //?=====================Leave Popup================================
  const handleClose = () => {
    if (showLeaveAuthRoutePopup)
      if (typeof cancelNavigation === "function") {
        cancelNavigation();
      }
  };

  const handleConfirm = () => {
    if (showLeaveAuthRoutePopup) {
      if (typeof confirmNavigation === "function") {
        confirmNavigation();
      }
      dispatch(updateOTPDuration(0));
      dispatch(setIsUserRegistering(false));
      dispatch(setIsUserForgettingPassword(false));
      dispatch(
        setIsCompleteRegister({
          isCompleteRegister: false,
        }),
      );
      changeShowLeaveAuthRoutePopupAuthState(false);
      localStorage.removeItem("otpDuration");

      if (user?.token && isAuthenticated) {
        setTimeout(() => {
          navigate("/", { replace: true });
          window.location.reload();
        }, 200);
      } else {
        setTimeout(() => {
          navigate("/auth/login", { replace: true });
          window.location.reload();
        }, 200);
      }
    }
  };

  useEffect(() => {
    if (
      isUserRegistering === false &&
      isUserForgettingPassword === false &&
      isCompleteRegister === false
    ) {
      navigate("/auth/login", {
        replace: true,
      });
    }
  }, [isUserRegistering, isUserForgettingPassword, isCompleteRegister]);

  return (
    <>
      {children}
      {showLeaveAuthRoutePopup && (
        <LeaveAlert
          show={showPrompt}
          setShow={() => {
            handleClose();
          }}
          handleConfirm={() => {
            handleConfirm();
          }}
        />
      )}
    </>
  );
};

export default AuthGuard;
